import React from 'react';

function Footer() {
  return (
    <footer className=" text-white p-2 bg-gray-500">
      <p className="text-center font-semibold tracking-wide">
        Copyrights &copy; 2022
      </p>
    </footer>
  );
}

export default Footer;
